// Copyright 2026. WebPros International GmbH. All rights reserved.

import { Icon } from '@plesk/ui-library';

interface IProps {
    value: boolean;
}

export default function CheckCrossIcon({ value }: IProps) {
    if (value) {
        return (
            <Icon
                name={'check-mark-circle'}
                intent={'success'}
            />
        );
    }

    return (
        <Icon
            name={'remove'}
            intent={'danger'}
        />
    );
}
